import { useSyncExternalStore } from 'react';

import { PHONE_MEDIA_QUERY } from '@/constants/my-access';

const subscribe = (onChange: () => void): (() => void) => {
  const query = window.matchMedia(PHONE_MEDIA_QUERY);

  query.addEventListener('change', onChange);

  return () => query.removeEventListener('change', onChange);
};

/** True below `sm`; follows the window as it is resized or turned. */
export const useIsPhone = (): boolean =>
  useSyncExternalStore(subscribe, () => window.matchMedia(PHONE_MEDIA_QUERY).matches);
